/** Matches backend profile-validation.ts rules */
const PHONE_FORMAT_PATTERN = /^\+?[\d\s().-]{10,20}$/;

export function validatePhoneNumber(value) {
  if (!value || !String(value).trim()) {
    return "Phone number is required";
  }
  const trimmed = String(value).trim();
  if (!PHONE_FORMAT_PATTERN.test(trimmed)) {
    return "Invalid phone number format";
  }
  const digits = trimmed.replace(/\D/g, "");
  if (digits.length < 10 || digits.length > 15) {
    return "Phone number must contain between 10 and 15 digits";
  }
  return null;
}

export const phoneNumberRules = [
  { required: true, message: "Please enter a phone number" },
  {
    validator: (_, value) => {
      const error = validatePhoneNumber(value);
      if (error) {
        return Promise.reject(new Error(error));
      }
      return Promise.resolve();
    },
  },
];
